// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".dropdown_5d7 {\n  display: inline-block;\n}\n\n.anchor_93a.anchor_93a {\n  margin: 0 -3px;\n  padding: 0 3px;\n\n  font: inherit;\n}\n\n.chevron_7e5 {\n  margin-left: 2px;\n\n  line-height: normal;\n}\n", ""]);
// Exports
exports.locals = {
	"dropdown": "dropdown_5d7",
	"anchor": "anchor_93a",
	"chevron": "chevron_7e5"
};
module.exports = exports;
